import { render, staticRenderFns } from "./myHomePage.vue?vue&type=template&id=10b8ae78&scoped=true&"
import script from "./myHomePage.vue?vue&type=script&lang=ts&"
export * from "./myHomePage.vue?vue&type=script&lang=ts&"
import style0 from "./myHomePage.vue?vue&type=style&index=0&id=10b8ae78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8ae78",
  null
  
)

export default component.exports